module.exports = __webpack_public_path__ + "media/images/friend-68b47f88c0cfc473ce73d12d970d2899.jpg";